import React, { useEffect, useState, useRef, use } from "react";

import { EditorState, ContentState, Modifier } from "draft-js";
import "draft-js/dist/Draft.css";
import { IconButton } from "@material-ui/core";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import UploadIcon from "@mui/icons-material/Upload";
import MicIcon from "@mui/icons-material/Mic";
import { Menu, MenuItem } from "@material-ui/core";
import {Delete} from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  checkGrammar,
  checkGrammarFluency,
  checkOCR,
} from "../../services/englishCheckers";
import Loader from "../../utils/loader";
import EditIcon from "@mui/icons-material/Edit";
import { toast, ToastContainer } from "react-toastify";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@mui/icons-material/Check";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CoAutherTopMenubar from "../pages/CoAutherTopMenubar";
import CoauthorModal from "./FormComponents/CoAuthor_Model";
import { ListItemText } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import SelectDropdownMui from "../ReusableComponents/SelectDropdownMui";
import CoAuthorLowerModel from "./FormComponents/CoAuthorLowerModel";
import { strCount } from "../Editor/utilize";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import documentService from "../../services/document";
import { useDispatch, useSelector } from "react-redux";
import { resetTemplateName } from "../../redux/coauthor/coauthor.action";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  closeLeftNavbar,
  closeLowerModalAndOpenLeftNavbar,
  openLeftNavbar,
  openLowerModalAndCloseLeftNavbar,
  closeLowerModal,
} from "../../redux/handleSideNavBarAndModel/handleStatus.action";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useLocation } from "react-router-dom";
import htmlToDraft from "html-to-draftjs";
import swal from "sweetalert";
import { reviewDocument } from "../../services/teamCollbarationServices";
import blogService from "../../services/blogServices";
import { DownloadOptionModal } from "../MyDocumentsCardsModal";
import aireviewicon from "../../static/AI_Review_color.png";
import paraphrase_logo from "../../static/Paraphrase 1.png";
import paraphrase_White from "../../static/Paraphraser_White.png";
import paraphrase_Gray from "../../static/Paraphrase 2.png";
import HeadingB from "../Cards/HeadingB";
import JoditEditor from "jodit-react";
import JoditEditorComp from "../ReusableComponents/JoditEditorComp";
import SuggestionComp from "../ReusableComponents/SuggestionComp";
import TagButtonComp from "../ReusableComponents/TagButtonComp";
import CheckboxMui from "../ReusableComponents/CheckBoxMui";
import { FaBookOpen } from "react-icons/fa";
import { asBlob } from "html-docx-js-typescript";
import { saveAs } from "file-saver";
import { CoAuthor_Aireviewcomponent } from "./FormComponents/CoAuthor_Aireview";
import CloseIcon from "@mui/icons-material/Close";
import {
  closeRightModalAndOpenLeftNavbar,
  openRightModalAndCloseLeftNavbar,
  closeRightModal,
} from "../../redux/handleSideNavBarAndModel/handleStatus.action";
import "./CoAuthorNewProject.css";
import {
  fullSizeEditor,
  normalSizeEditor,
} from "../../redux/manageFullSizeEditor/fullSizeEditor.action";
import {
  selectCoauthorContent,
  clearCoauthorContent,
} from "../../redux/coauthorSelectedContent/coauthorSelectedContent.action";
import { addUserLogs } from "../../services/userLogServices";
import { useCheckFeatureAccess } from "../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
import SubscriptionRequired from "../SubscriptionRequired";
import { checkAIRequestLimit } from "../aiRequestLimit";
import RichTextEditor from "../ReusableComponents/CustomEditor";
import mammoth from "mammoth";
import { Spellcheck } from "@mui/icons-material";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const CoAuthorNewProject = ({
  docId,
  isCoAuthor = true,
  isGrammarCheck,
  trial = false,
  userId,
  hidecorrectnessbar,
}) => {
  const editorRef = useRef(null);
  const editor = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { transcript, resetTranscript } = useSpeechRecognition();

  // ---------- useStates ----------------
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [secondaryeditorStateSummarizer, setSecondaryEditorStateSummarizer] =
    useState(EditorState.createEmpty());
  const [trackIsModelOpen, setTrackIsModalOpen] = useState(true);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [editorHtmlContent, setEditorHtmlContent] = useState("");
  const [acceptAllClicked, setAcceptAllClicked] = useState(false);
  const [ignoreAllClicked, setIgnoreAllClicked] = useState(false);
  const [imgInEditor, setImgInEditor] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [docApiCalled, setDocApiCalled] = useState(false);
  const [blogApiCalled, setBlogApiCalled] = useState(false);
  const [newDocId, setNewDocId] = useState("");
  const [circularLoader, setCircularLoader] = useState(false);
  const [viewOnlyAccess, setViewOnlyAccess] = useState(false);
  const [totalWords, setTotalWords] = useState(0);
  const [maxCountDisplayed, setMaxCountDisplayed] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [editDropdown, setEditDropdown] = useState(null);
  const [selectedEditOption, setSelectedEditOption] = useState(true);
  const [showTranslator1, setShowTranslator1] = useState(false);
  const [showSummariser1, setShowSummariser1] = useState(false);
  const [showParaphraser1, setShowParaphraser1] = useState(false);
  const [callGrammerCheck, setCallGrammerCheck] = useState(false);
  const [firstTime, setFirstTime] = useState(0);
  const [callSummarise, setCallSummarise] = useState(false);
  const [showTranslateModel, setShowTranslateModel] = useState(false);
  const [sharedState, setSharedState] = useState("");
  const [docName, setDocName] = useState("");
  const [mountedFromUpload, setMountedFromUpload] = useState(false);
  const [sharedDocument, setSharedDocument] = useState(false);
  const [removeHighlight, setRemoveHighlight] = useState(false);
  const [clickSubmitForReview, setClickSubmitForReview] = useState(false);
  const [isModifiedDoc, setIsModifiedDoc] = useState(false);
  const [docInitialContent, setDocInitialContent] = useState("");
  const [docCurrentContent, setDocCurrentContent] = useState("");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [folderId, setFolderId] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [sentenceResult, setSentenceResult] = useState([]);
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [formality, setFormality] = useState("");
  const [tone, setTone] = useState("");
  const [newSentences, setNewSentences] = useState([]);
  const [suggestionLoader, setSuggestionLoader] = useState(false);
  const [profession, setProfession] = useState("");
  const [tags, setTags] = useState([]);
  const [showAireviewContent, setshowAireviewContent] = useState(false);
  const [showGoals, setShowGoals] = useState(false);
  const [ignoredSuggestions, setIgnoredSuggestions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [editorValue, setEditorValue] = useState("");
  const [isFeatureInside, setIsFeatureInside] = useState(false);
  // ---------- useStates End----------------

  //----------- UseSelectors ---------------------
  const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
  const userDetails = useSelector((user) => user);
  const userID = userId ? userId : userDetails.user.currentUser._id;
  const currentNavItem = useSelector(
    (state) => state.manageCoauthorNavReducer.currentCoauthorNavItem
  );
  const uploadDocumentValue = useSelector(
    (state) => state.templateName.uploadDocument
  );
  const sharedFolderId = useSelector(
    (state) => state.templateName.shareFolderId
  );
  const { clickState } = useSelector((state) => state.handleClick);
  const sharedDocumentValue = useSelector(
    (state) => state.templateName.sharedDocumentStatus
  );
  const selectedTemplateName = useSelector(
    (state) => state.templateName.templateName
  );
  const { rightModalOpen, leftNavbarOpen, lowerModelOpen } = useSelector(
    (state) => state.handleModelAndSideBavBar
  );
  //----------- UseSelectors End-----------------

  //----------- FeatureAccess ---------------
  const accessToParaphrase = useCheckFeatureAccess(
    currentNavItem,
    "paraphrase"
  );
  const accessToSummarize = useCheckFeatureAccess(currentNavItem, "summarize");
  const accessToNewDoc = useCheckFeatureAccess(currentNavItem, "newDocument");
  const accessToWriteBlog = useCheckFeatureAccess(currentNavItem, "writeBlog");
  const accessToEdit = accessToNewDoc || accessToWriteBlog;
  const accessToOCR = useCheckFeatureAccess(currentNavItem, "ocr");
  const accessToDelete = useCheckFeatureAccess(currentNavItem, "delete");
  const accessToUpload = useCheckFeatureAccess(currentNavItem, "upload");
  const accessToTranslate = useCheckFeatureAccess(currentNavItem, "translate");
  const accessToMic = useCheckSubscriptionPlanAccess("mic");
  //----------- FeatureAccess End --------------

  //----------- Subscription access ------------
  const accessToDocumentScreen = useCheckSubscriptionPlanAccess("Document");
  const accessToGrammarCheckScreen =
    useCheckSubscriptionPlanAccess("Grammar Check");
  const accessToCoAuthorScreen = useCheckSubscriptionPlanAccess("CoAuthor");
  const accessToBlogScreen = useCheckSubscriptionPlanAccess("Blogs");
  const accessToTagsScreen = useCheckSubscriptionPlanAccess("Tags");
  //----------- Subscription access end-----------

  const professionList = [
    {
      name: "Content Writer",
      value: "Content Writer",
    },
    {
      name: "Copywriter",
      value: "Copywriter",
    },
    {
      name: "Technical writer",
      value: "Technical writer",
    },
    {
      name: "Research Analyst",
      value: "Research Analyst",
    },
  ];

  const templateData = [
    {
      name: "Cold-Email",
      data: `<div >

      <p><h3>Subject Line:</h3> Compelling Subject That Grabs Attention</p>

      <p><h3>Greeting:</h3> Hi [Recipient's Name],</p>

      <p><h3>Introduction:</h3> I hope this email finds you well. My name is [Your Name], and I am reaching out to you. [Briefly introduce yourself and mention a common interest or connection.]</p>

      <p><h3>Value Proposition:</h3> I want to share with you the exciting value [Your Product/Service/Proposition] brings. [Explain how it can benefit the recipient and address a pain point.]</p>

      <p><h3>Relevance:</h3> Considering [Recipient's Company/Needs/Challenges], I believe our [Product/Service/Proposition] is particularly relevant. [Customize and explain why it aligns with their specific situation.]</p>

      <p><h3>Call to Action:</h3> I would love to discuss this further with you. Could we schedule a brief call at your earliest convenience? [Provide options for scheduling or another clear CTA.]</p>

      <p><h3>Social Proof (Optional):</h3> We've had success working with companies like [Client Name] and achieved [mention any notable achievements]. [Optional: Include a brief testimonial or success story.]</p>

      <p><h3>Closing:</h3> Thank you for considering [Your Product/Service/Proposition]. I look forward to the possibility of working together.</p>

      <p><h3>Best regards:</h3> <br> [Your Full Name] <br> [Your Position] <br> [Your Company]</p>

      <p><h3>Contact Information:</h3> <br> [Your Email Address] <br> [Your Phone Number]</p>


      </div>
      `,
    },
    {
      name: "Resume",
      data: `  <div style={{margin:"10px"}}>
      <span><strong>Your Name :</strong> Lorem ipsum dolor sit amet, consectetuer adipiscing elit </span> <br />

    <span>  <strong>Address :</strong> 123 Your Street <br />
      Your City, ST 12345 <br />
      (123) 456-7890 <br />
      no_reply@example.com
    </span>

    <div class="section" style="margin-top: 20px">
      <h3>EXPERIENCE</h3>
      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - PRESENT<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>

      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>

      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>EDUCATION</h3>
      <p>
        <strong>School Name, Location — Degree</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore.
      </p>

      <p>
        <strong>School Name, Location — Degree</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>PROJECTS</h3>
      <p>
        <strong>Project Name — Detail</strong><br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>SKILLS</h3>
      <ul>
        <li>Lorem ipsum dolor sit amet.</li>
        <li>Consectetuer adipiscing elit.</li>
        <li>Sed diam nonummy nibh euismod tincidunt.</li>
        <li>L​​​‌​aoreet dolore magna aliquam erat volutpat.</li>
      </ul>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>AWARDS</h3>
      <p>
        <span>Lorem ipsum dolor sit amet Consectetuer adipiscing elit, Sed diam nonummy Nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</span>
      </p>

      <p>
        <span>Lorem ipsum dolor sit amet Consectetuer adipiscing elit, Sed diam nonummy Nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</span>
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>LANGUAGES</h3>
      <p>Lorem ipsum, Dolor sit amet, Consectetuer</p>
    </div>  <div>`,
    },
    {
      name: "Essay",
      data: `<div >



      <h3>Introduction</h3>

      <p>
        Your essay begins with your introduction. It is important to capture your reader’s interest, so make sure you have an attention-grabbing hook. Your introduction is a paragraph that provides your reader with the relevant general background information on your topic. Using this context to ease your reader into the subject, you should then state your thesis statement. This is the main focus of your essay. A thesis statement is not a fact but something that can be discussed and analyzed. After stating your thesis, you should include an organizational statement. This functions as a roadmap that introduces the points you will make to support your thesis in the order in which they will appear in your body paragraphs.
      </p>

      <br />

      <h3>Body Paragraphs:</h3>

      <p>
        Body paragraphs are the bulk of your essay that provides substance to your argument with core analysis. These paragraphs are composed of points to support your thesis statement. It is helpful to separate your main claims into different paragraphs, making each claim a topic sentence. A topic sentence begins a body paragraph, introducing what your paragraph will be about. You must provide evidence (such as researched quotes or statistics) to back up and explore your topic sentence. You must provide the appropriate references for any evidence you cite. The evidence provided must be analyzed to explain how this idea proves or backs up your thesis. It is important that everything in your essay should be relevant to your thesis. This link is made at the end of the paragraph, tying back to the thesis statement and leading into the next point as a transition sentence. It is important to cite and use transition words in your essay to help create a smooth flow of your ideas. You may have as many body paragraphs as you’d like, but each body paragraph will follow the same format (beginning with a topic sentence, providing evidence and analysis to back up this claim, before linking your idea with your thesis statement).
      </p>

      <br />

      <h3>Conclusion</h3>

      <p>
        Your conclusion is the wrap-up of your essay. Here you must summarize the main points of your essay. You are to review your topic sentences and main argument, but you must not introduce any new ideas to your essay at this stage. Instead, re-emphasize your thesis statement and how your evidence and analysis support your points. In your concluding thoughts, you could appeal to the readers to see that you have come to a logical conclusion. You could also show why your argument matters, or simply end your essay with a memorable final statement.
      </p>

      <br />

      <h3>References:</h3>

      <p>
        If you have included evidence via in-text citations in your essay, you must cite it fully in a References section at the end of your essay. It is recommended to use either APA or MLA citations.
      </p>

      <br />
      <br />

      <h3>Structure:</h3>

      <p>An essay can be broken down into three main sections.</p>

      <br />

      <h3>Introduction</h3>

      <ul>
        <li>Background information</li>
        <li>Thesis statement</li>
        <li>Organizational statement/roadmap</li>
      </ul>

      <br />

      <h3>Body Paragraphs (repeat as many times as needed)</h3>

      <ul>
        <li>Topic Sentence</li>
        <li>Evidence</li>
        <li>Analysis</li>
        <li>Link to the thesis statement</li>
      </ul>

      <br />

      <h3>Conclusion</h3>

      <ul>
        <li>To sum up the main points,</li>
        <li>Then tie it back to the thesis statement.</li>
        <li>Final thoughts</li>
      </ul>

      <br />

      <p>
        If needed, include a references section at the end for any works cited.
      </p>



      </div>`,
    },
    {
      name: "Business Letter",
      data: `<div style={{margin:"10px"}}>

      <h3>Your Company's Letterhead</h3>
      <p>
        <span>If applicable, include your company's letterhead at the top of the letter, which typically features the company's logo, name, address, and contact information.</span>
      </p>

      <h3>Date</h3>
      <p>
        <span>Below the letterhead or your address, add the current date. Format it as Month Day, Year (e.g., August 15, 2023).</span>
      </p>

      <h3>Recipient's Address</h3>
      <p>
        <span>Leave a few lines and then include the recipient's name, title, company name, street address, city, and postal code.</span>
      </p>

      <h3>Salutation</h3>
      <p>
        <span>Start with a formal salutation, addressing the recipient with their appropriate title and last name (e.g., 'Dear Mr. Smith,').</span>
      </p>

      <h3>Body of the Letter</h3>
      <p>
        <span>In the body of the letter, maintain a professional and formal tone. Address the purpose of the letter, provide details, and communicate your message clearly.</span>
      </p>

      <h3>Closing</h3>
      <p>
        <span>Close the letter with a formal closing (e.g., 'Sincerely,' 'Yours faithfully,') followed by your full name and title.</span>
      </p>

      <h3>Signature (If Applicable)</h3>
      <p>
        <span>Leave space for your physical signature above your typed name. If the letter is being sent digitally, you can skip this step.</span>
      </p>

      <h3>Enclosures (If Applicable)</h3>
      <p>
        <span>If you're enclosing additional documents or materials, list them below your signature or closing.</span>
      </p>


      </div>
      `,
    },
    {
      name: "Meeting-Notes",
      data: `


      <div  >
      <!-- Meeting Details -->
<h3>Meeting Date:</h3>
<p>[Insert Meeting Date]</p>

<h3>Time:</h3>
<p>[Insert Meeting Time]</p>

<h3>Location:</h3>
<p>[Insert Meeting Location, if applicable]</p>

<!-- List of Attendees -->
<h3>List of Attendees:</h3>
<p>
  Attendant's name<br />
  Attendant's name<br />
  Attendant's name
</p>

<!-- Agenda -->
<h3>Agenda:</h3>
<p>
  <em>Topic 1:</em> [Insert Topic 1]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]<br />

  <em>Topic 2:</em> [Insert Topic 2]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]<br />

  <em>Topic 3:</em> [Insert Topic 3]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]
</p>

<!-- Discussion and Decisions -->
<h3>Discussion and Decisions:</h3>
<p>
  Provide a summary of the discussions for each agenda item. Include key points, viewpoints, and decisions made.
</p>

<!-- Action Items -->
<h3>Action Items:</h3>
<p>
  - [Action Item 1: Description, Assigned to, Due Date]<br />
  - [Action Item 2: Description, Assigned to, Due Date]<br />
  - [Action Item 3: Description, Assigned to, Due Date]
</p>

<!-- Next Steps -->
<h3>Next Steps:</h3>
<p>
  Outline the next steps to be taken after the meeting, including tasks, responsibilities, and timelines.
</p>

<!-- Open Issues -->
<h3>Open Issues:</h3>
<p>
  Note any issues or topics that require further discussion or resolution. Specify who will address these issues and when.
</p>

<!-- Additional Notes -->
<h3>Additional Notes:</h3>
<p>
  Include any additional notes, comments, or observations relevant to the meeting.
</p>

<!-- Upcoming Meetings -->
<h3>Upcoming Meetings:</h3>
<p>
  Mention the dates and times of upcoming meetings related to the discussed topics, if applicable.
</p>

      </div>

      `,
    },
    {
      name: "Article",
      data: `

      <div style={{margin:"10px"}}>
      <!-- Introduction -->
<h3>Introduction</h3>
<p>
  The introduction should engage the reader and provide an overview of the article's main topic. Start with a hook, present the key issue, and state the purpose or thesis of the article.
</p>

<!-- Main Content -->
<h3>Main Content</h3>
<p>
  This section is the heart of your article. Organize the content based on the type of article you're writing:
</p>

<!-- News/Feature Article -->
<h3>News/Feature Article:</h3>
<p>
  Provide relevant facts, details, quotes, and anecdotes to present the story or topic.
</p>

<!-- Opinion/Editorial Article -->
<h3>Opinion/Editorial Article:</h3>
<p>
  Present your opinion, supported by logical reasoning, evidence, and examples.
</p>

<!-- Review Article -->
<h3>Review Article:</h3>
<p>
  Evaluate the subject of the review objectively, discussing its strengths, weaknesses, and overall quality.
</p>

<!-- Research/How-To Article -->
<h3>Research/How-To Article:</h3>
<p>
  Share research findings, instructions, tips, or information on the chosen topic.
</p>

<!-- Interview/Profile Article -->
<h3>Interview/Profile Article:</h3>
<p>
  Share insights from the interviewee or profiled individual, focusing on their experiences, expertise, and perspectives.
</p>

<!-- Conclusion -->
<h3>Conclusion</h3>
<p>
  Summarize the main points of the article and reiterate its significance. Conclude with a thought-provoking statement, a call to action, or a reflection on the topic discussed.
</p>

<!-- Additional Sections (Optional) -->
<h3>Additional Sections (Optional)</h3>
<p>
  Depending on the article type, you might include additional sections such as:
</p>

<!-- References/Citations -->
<h3>References/Citations:</h3>
<p>
  List sources cited or referenced in the article.
</p>

<!-- Author Bio -->
<h3>Author Bio:</h3>
<p>
  Provide a brief biography of the author, including relevant credentials.
</p>

<!-- Visuals -->
<h3>Visuals:</h3>
<p>
  Include images, graphs, charts, or infographics to enhance the content.
</p>

      </div>
      `,
    },
    {
      name: "Blog",
      data: `

      <div style={{margin:"10px"}}>

      <h3>The Blog Post</h3>
      <p>
        This is a classic blog post template, often known as the 'Listicle'. It usually comprises a list of anywhere between 10–30 items that have a reason to be listed (such as tips, techniques, myths, strategies, etc. This type of list is usually used for displaying non-chronological information.
      </p>

      <!-- To use this template -->
      <h3>To use this template:</h3>
      <p>
        Your title should be numbered for the number of items listed in the article. There must be a specific benefit or purpose for your article to make it compelling. Your title should be attention-grabbing. Possible examples:
      </p>

      <!-- Title Examples -->
      <ul>
        <li>'X Important Tips to Achieve [Desired Outcome]'</li>
        <li>
          'X Reasons Why [Problem] Still Persists Despite All Your Attempts'
        </li>
        <li>'X Myths You Need to Stop Believing'</li>
      </ul>

      <!-- Introduction -->
      <h3>Introduction</h3>
      <p>
        Your article should begin by establishing trust with the reader by introducing the problem the reader has and proving the benefit the reader will get from reading your article. Your introduction should be as short as possible. It is advised to include a linked table of contents with jump links so readers can skip right to the tip that interests them if they would like to.
      </p>

      <!-- Subheadings -->
      <h3>Subheadings</h3>
      <p>
        These are important to give readers an overview of what that specific section is about. They also break up your content into manageable chunks. Subheadings should be descriptive and reveal a clear benefit. This will boost the perceived value of each section to help grab readers’ attention to read the section. It is up to you to choose whether or not to number your subheadings. Subheadings should be in head level 2 format.
      </p>

      <!-- Action Items -->
      <h3>Action Items</h3>
      <p>
        Action items are sometimes overlooked in how important they can be. These are the steps a reader will have to take to complete or achieve each item on your list. Including action items is simple: just include the step-by-step information to help readers follow your steps. Often it is helpful to include photos or video visuals.
      </p>

      <!-- Conclusion -->
      <h3>Conclusion</h3>
      <p>
        It is important to wrap up your blog post. You can decide how you want to do this, but most lists end by listing a few more final tips. Your conclusion should leave readers wanting to actually use the information they have received from your blog. You can also encourage them to interact with your post, such as liking, sharing, and commenting.
      </p>

      </div>
      `,
    },
    {
      name: "Appendix",
      data: `
      <div style={{ margin: "50px", backgroundColor: "violet" }}>


      <!-- Appendix A: Protocol -->
      <h3>Appendix A: Protocol</h3>
      <p>
        This example shows how you could format a protocol for your research paper, thesis, or dissertation.
      </p>

      <!-- Materials -->
      <h3>Materials</h3>
      <p>
        The materials for this study can be subdivided into five different types:
      </p>
      <ol>
        <li>Sustained vowel [a:] by COPD speakers during exacerbation;</li>
        <li>Sustained vowel [a:] by COPD speakers during stable COPD;</li>
        <li>Storytelling of ‘The King’ by COPD speakers during exacerbation;</li>
        <li>Storytelling of ‘The King’ by COPD speakers in stable condition;</li>
        <li>Storytelling of ‘Mary and Adam’ by healthy speakers.</li>
      </ol>

      <!-- Type 1: Sustained vowels -->
      <h3>Type 1: Sustained vowels</h3>
      <p>
        The sustained vowels were recorded shortly before or after reading aloud. The King. The vowels were isolated and saved as a separate recording, but this type of speech did not require further annotation before analysis.</p>
        <h3>Type 1-4: Storytelling of COPD speakers and healthy speakers</h3>
      <p>
        Speech types 1-4 were prepared and annotated following the same steps:
      </p>
      <ul>
        <li>
          Each file was clipped to remove the instructions preceding the reading task and the commentary after the reading task.
        </li>
        <li>
          The files were then converted using Praat, changing the sample size from 44 kHz to 16 kHz to prepare the files for forced alignment.
        </li>
        <li>
          The transcript of each file was added in the first interval tier ‘transcript’ to prepare the files for forced alignment.
        </li>
        <li>
          Each file was processed using the forced aligner according to its manual (Xue, De Reus, & Merkus, 2019; see Appendix D), creating two additional interval tiers ‘wordsegmentation’ and ‘phoneticsegmentation’ containing the segmentations of the transcripts on word and phoneme level (in SAMPA).
        </li>
        <li>
          These segmentations on both levels were then manually checked and corrected.
        </li>
        <li>
          After finalizing the segmentation process, three more tiers were manually added to each file for the annotation process. The first (interval) tier ‘respiratory’ was added for respiratory-related annotations, such as ‘inhalation’, ‘exhalation’, ‘pause’. This way, information about the respiratory pattern could be obtained.
        </li>
        <li>
          The second (point) tier ‘speakernoise’ was added for voice quality-related annotations, such as ‘cough’, ‘creaky’, ‘slimy’, to obtain information regarding the voice quality of the speaker. A point tier was preferred over an interval tier because the study focused on the number of occurrences.
        </li>
        <li>
          The third (interval) tier ‘commentary’ was added to clarify the speaker noises or to keep a record of additional observations. The respiratory tier and the speakernoise tier were annotated separately.
        </li>
        <li>
          The first tier to be annotated was the respiratory tier. Each silence interval was studied to determine if the speaker was inhaling (in), exhaling (ex), or if there was an audible pause (p). This way, the transcript could be subdivided into different ‘breathing groups’. The commentary tier was used to specify the annotations.
        </li>
        <li>
The second tier to be annotated was the speakernoise tier. The fragment was replayed to obtain information about the condition of the voice. Audible disturbances, such as hoarseness, creakiness, and sliminess of the voice, were addressed using the speakernoise tier to indicate the occurrence, and the commentary tier to describe the nature of the disturbance.
        </li>
        <li>
          The fragment was then replayed a final time to check the annotations.
        </li>
      </ul>

      <!-- Appendix B: Survey Questions -->
      <h2>Appendix B: Survey Questions</h2>
      <p>
        This example shows how you could format survey questions for your research paper, thesis, or dissertation.
      </p>

      <!-- General questions -->
      <h3>General questions</h3>
      <ol>
        <li>What is your age?</li>
        <li>
          What is the gender you identify with?
          <ul>
          <li></li>
            <li>a) Female</li>
            <li>b) Male</li>
            <li>c) Non-binary</li>
            <li>d) Other</li>
            <li>e) Don’t want to say</li>
          </ul>
        </li>
        <li>
          What is the highest degree or level of school you have completed? If currently enrolled, the highest degree received.
          <ul>
          <li></li>
            <li>a) ...</li>
            <li>b) ....</li>
            <li>c) ...</li>
          </ul>
        </li>
      </ol>


      <!-- Appendix C: Interview Transcript 1 -->
      <h2>Appendix C: Interview Transcript 1</h2>
      <p>
        Interviewer: Thank you very much for your time today and for agreeing to participate in this interview. May I have your consent to video-record?
      </p>
      <p>Participant 1: Yes.</p>
      <p>Interviewer: Great, thank you. I’ll begin the recording now.</p>
      <p>Participant 1: Sounds good.</p>
      <p>
        Interviewer: Okay, we’re ready to get started. My first question is about what you would say your motivation was when you first decided to volunteer for the Army.
      </p>
      <p>
        Participant 1: I wouldn’t say I had motivation, I was against the war. I was drafted, which meant that I had to go regardless of if I wanted to. I had recently gotten married to my first wife and was enjoying helping my dad out at the family hardware store, but when my number got called up I had to go.
      </p>

      <!-- Appendix C: Interview Transcript 2 -->
      <h2>Appendix C: Interview Transcript 2</h2>
      <p>
        Interviewer: Thank you very much for your time today and for agreeing to participate in this interview. May I have your consent to video-record?
      </p>
      <p>Participant 2: I would prefer that you only audio-recorded.</p>
      <p>
        Interviewer: Okay, no problem, look, you can see here I am just pressing audio, not video.
      </p>
      <p>Participant 2: I appreciate that.</p>
      <p>
        Interviewer: Okay, so let’s get started. My first question is about what you would say your motivation was when you first decided to join the Army.
      </p>
      <p>
        Participant 2: Well, the war in Vietnam had just started, and my twin brother and I were freshmen in college at the time. We decided to join on our own terms, rather than wait to be drafted. He ended up in the Airborne Division, while I ended up in the Cavalry Division.
      </p>
      </div>
      `,
    },
  ];

  // for access
  useEffect(() => {
    const accessMap = {
      Documents: accessToDocumentScreen,
      grammerChaeck: accessToGrammarCheckScreen,
      coAuthor: accessToCoAuthorScreen,
      blogs: accessToBlogScreen,
      Tags: accessToTagsScreen,
    };
    console.log("accessToGrammarCheckScreen",accessToGrammarCheckScreen,currentNavItem)
    // if currentNavItem exists in accessMap and user doesn’t have access
    if (accessMap[currentNavItem] === false) {
      setSubReqOpen(true);
    }
  }, [
    currentNavItem,
    accessToDocumentScreen,
    accessToGrammarCheckScreen,
    accessToCoAuthorScreen,
    accessToBlogScreen,
    accessToTagsScreen,
  ]);

  useEffect(() => {
    // 1️⃣ Initialization effects that run once on mount
    const handleResize = () => setWindowWidth(window.innerWidth);
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    // setup listeners
    window.addEventListener("resize", handleResize);
    window.addEventListener("storage", updateTheme);
    updateTheme();
    // override localStorage.setItem for live theme sync
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") updateTheme();
    };
    checkIgnoredSentence();
    dispatch(closeLowerModalAndOpenLeftNavbar());
    // cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
      if (isRecording) {
        SpeechRecognition.stopListening();
        resetTranscript();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2️⃣ Sync effects for state/prop changes
  useEffect(() => setFolderId(sharedFolderId), [sharedFolderId]);
  useEffect(
    () => setMountedFromUpload(uploadDocumentValue),
    [uploadDocumentValue]
  );
  useEffect(
    () => setSharedDocument(sharedDocumentValue),
    [sharedDocumentValue]
  );

  // 3️⃣ Handle blog/document content loading from location/state
  useEffect(() => {
    console.log("useEffectCheck_", location.state, docId);
    if (location.state?.blogContent) {
      setEditorContentUpload(location.state.blogContent);
      setDocName(location.state.blogName);
      setTags(location.state.blogTags);
    } else if (location.state && !docId && !mountedFromUpload) {
      const { fileContent } = location.state;
      setEditorContentUpload(fileContent);
    } else if (location.state && mountedFromUpload && !docId) {
      const { fileContent, fileName } = location.state;
      setDocName(fileName);
      setEditorValue(fileContent);
      setMountedFromUpload(false);
    }
  }, [location.state, docId, mountedFromUpload]);

  // 4️⃣ Template insertion
  useEffect(() => {
    if (!selectedTemplateName || !editorRef.current) return;
    const selectedTemplate = templateData.find(
      (data) => data.name === selectedTemplateName
    );
    if (!selectedTemplate) return;
    // REPLACE content completely whenever template changes
    editorRef.current.innerHTML = selectedTemplate.data;
    // Keep cursor at end and allow editing
    setTimeout(() => focusEditorAtEnd(), 0);
  }, [selectedTemplateName]);

  const focusEditorAtEnd = () => {
    const editor = editorRef.current;
    editor.focus();
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(editor);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  };

  // Document fetch
  useEffect(() => {
    if (docId) getDocById(docId);
  }, [docId]);

  // 6️⃣ View mode change
  useEffect(() => {
    handleMenuItemClick(viewOnlyAccess ? "Viewing" : "Editor View");
  }, [viewOnlyAccess]);

  // 8️⃣ Transcript and model changes
  useEffect(() => {
    if (transcript.length > 2) resetTranscript();
    if (!trackIsModelOpen) handleTranscriptChange();
  }, [transcript, trackIsModelOpen]);

  // 9️⃣ Log document modifications
  useEffect(() => {
    const logChanges = async () => {
      if (docCurrentContent && docInitialContent && !isModifiedDoc) {
        if (docCurrentContent !== docInitialContent) {
          try {
            const data = {
              userId: sessionStorage.getItem("userId"),
              organizationId: sessionStorage.getItem("organizationId"),
              actionType: "editDoc",
            };
            const addLogs = await addUserLogs(data);
            if (addLogs.status === 200) setIsModifiedDoc(true);
            else toast.error(addLogs.message);
          } catch (error) {
            toast.error("Failed to add logs");
            console.error("Error logging user activity:", error);
          }
        }
      }
    };
    logChanges();
  }, [docCurrentContent, docInitialContent, isModifiedDoc]);

  // 🔟 Handle save and typing logic
  useEffect(() => {
    console.log("CurrentText_", docName);
    if (
      clickState &&
      docName &&
      docName !== "Untitled Blog" &&
      docName !== "Untitled Document"
    ) {
      if (!docApiCalled && !docId && !blogApiCalled && !newDocId) {
        fetchData();
      } else {
        const [wordsCount, characterCount] = strCount(editorValue);
        setTotalWords(wordsCount);
        handleTextEditor(editorValue, wordsCount, characterCount);
      }
    }
  }, [docName, clickState, newDocId]);

  useEffect(() => {
    console.log("update_editorValue", editorValue);
    const typingTimer = setTimeout(handleStoppedTyping, 2000);
    return () => clearTimeout(typingTimer);
  }, [editorValue, docName, newDocId]);

  //  Grammar suggestion
  useEffect(() => {
    console.log("sentenceResult_", sentenceResult);
    if (sentenceResult?.length > 0) {
      setLoading(false);
      setSuggestionLoader(false);
    }
    // else {
    //   setIsSuggestion(false);
    // }
  }, [sentenceResult]);

  //  Autosave
  useEffect(() => {
    if (editorValue !== "") {
      const [wordsCount, characterCount] = strCount(editorValue);
      const socketData = {
        documentName: docName,
        documentId: docId || newDocId,
        onlyDocumentContent: editorValue,
        formattedDocumentContent: editorValue,
        wordsCount,
        characterCount,
        folder: folderId || null,
        tags,
      };

      if (clickState === "blog") autoSaveBlogContent22(socketData);
      else autoSaveContent22(socketData);
    }
  }, [imgInEditor]);

  //  Selection tracking
  useEffect(() => {
    const handleSelectionChange = () => {
      const selectedText = window.getSelection().toString();
      if (selectedText) dispatch(selectCoauthorContent(selectedText));
      else dispatch(clearCoauthorContent());
    };
    document.addEventListener("selectionchange", handleSelectionChange);
    return () =>
      document.removeEventListener("selectionchange", handleSelectionChange);
  }, [dispatch]);

  const mobileView = windowWidth < 1330;

  const checkIgnoredSentence = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      let id = userId;
      const response = await documentService.getIgnoredSuggestions(id);
      if (response.getPhrases.length > 0) {
        setIgnoredSuggestions(response.getPhrases);
      }
    } catch (error) {
      console.log("Error in checking ignored suggestion.");
    }
  };

  let grammarCheckArray = [];
  let finalArray = [];

  const closeDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  const openDownloadModal = () => {
    setIsDownloadModalOpen(true);
  };

  const setEditorContentUpload = (textContent) => {
    if (editor.current) {
      const setContent = editor.current;
      setContent.setEditorValue(textContent);
    }
  };

  const handleTranslateClick = () => {
    let edtiortext = editorRef.current.innerText;
    if (edtiortext !== "") {
      setShowTranslateModel(true);
      setShowTranslator1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
    } else {
      toast.warn("Please enter some text");
    }

    setShowSummariser1(false);
    setShowParaphraser1(false);
  };

  const handleCloseTranslate = () => {
    setShowTranslateModel(false);
    setTrackIsModalOpen(false);
    dispatch(
      mobileView ? closeLowerModal() : closeLowerModalAndOpenLeftNavbar()
    );
    if (isFullSize) {
      dispatch(fullSizeEditor());
      dispatch(closeLeftNavbar());
    }
  };

  const getDocById = async (docId) => {
    console.log("CurrentText_", docId);
    try {
      const response = await documentService.getDocumentbyId(docId);
      if (response.status === 200) {
        const {
          documentName,
          onlyDocumentContent,
          readOnly,
          status,
          reviewStatus,
          tags,
        } = response.data.document;
        setTags(tags);
        setViewOnlyAccess(readOnly);
        if (readOnly) {
          setSelectedEditOption(false);
        } else {
          setSelectedEditOption(true);
        }
        if (reviewStatus == true) {
          setClickSubmitForReview(true);
        }
        if (documentName) {
          setEditorValue(response.data.documentBody);
          setDocName(documentName);
          if (editorRef.current) {
            editorRef.current.innerHTML = response.data.documentBody;
          }
          setIsTyping(false);
        } else {
          console.error(
            "Error: Document name or content is missing in the response data",
            response.data
          );
        }
      } else {
        console.error("Error fetching data:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  const handleSummariserClick = async () => {
    const checkailimit = await checkAIRequestLimit(userID);
    console.log(checkailimit, "_checkailimit");
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    // let edtiortext = editorRef.current.innerText
    // setEditorValue(edtiortext)
    if (editorValue !== "") {
      setShowTranslateModel(true);
      setShowSummariser1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
      if (callSummarise === false) {
        setCallSummarise(true);
      } else {
        setCallSummarise(false);
      }
    } else {
      toast.warn("Please enter text");
    }
    setShowTranslator1(false);
    setShowParaphraser1(false);
  };

  const handleParaphraseClick = async () => {
    const checkailimit = await checkAIRequestLimit(userID);
    console.log(checkailimit, "_checkailimit");
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    // let edtiortext = editorRef.current.innerText
    // setEditorValue(edtiortext)
    if (editorValue !== "") {
      setShowTranslateModel(true);
      setShowParaphraser1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
      if (callGrammerCheck === false) {
        setCallGrammerCheck(true);
      } else {
        setCallGrammerCheck(false);
      }
    } else {
      toast.warn("Please enter text");
    }
    setShowTranslator1(false);
    setShowSummariser1(false);
  };

  const handleEditDropdownOpen = (event) => {
    setEditDropdown(event.currentTarget);
  };
  const handleEditDropdownClose = () => {
    setEditDropdown(null);
  };
  const handleMenuItemClick = (option) => {
    handleEditDropdownClose();
    if (option === "Viewing") {
      setSelectedEditOption(false);
      dispatch(closeLeftNavbar());
    } else {
      setSelectedEditOption(true);
      dispatch(openLeftNavbar());
    }
  };

  function handleDeleteFormain() {
    console.log("delete clicl");
    if (editorRef.current) {
      // Access the editor instance using the current property of the ref
      // const cleareditor = editorRef.current;
      // editorRef.current.innerHTML = "";
      // Clear the content using the setContent method of the editor instance
      // cleareditor.setEditorValue("");
      editorRef.current.focus();
      document.execCommand("selectAll", false, null);
      document.execCommand("delete", false, null);
    }
    // setEditorContent("");
    setEditorValue("");
    setSentenceResult([]);
    setNewSentences([]);
    setIsSuggestion(false);
    resetTranscript();
    dispatch(resetTemplateName(""));
  }

  const handleDownloadFormain = () => {
    const htmlString = `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
    </head>
    <body>
        <h3>${docName}</h3>
        <hr/>
        ${editorHtmlContent}
    </body>
    </html>`;

    asBlob(htmlString).then((docx) => {
      saveAs(docx, `${docName}.docx`);
    });
  };

  function handleCopyFormain() {
    let sentence;
    if (editorRef.current) {
      sentence = editorRef.current.innerText;
    }
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
        if (sentence) toast.info("Your text Copied!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  // Delete function for summarizer  editor
  const handleDeleteInSummarizer = (data) => {
    if (data === true) {
      setSecondaryEditorStateSummarizer(EditorState.createEmpty());
    }
  };

  // ---- upload file ----
  const handleWordCountExceed = () => {
    if (!maxCountDisplayed) {
      toast.warn("Word count exceeded than 2500");
      setMaxCountDisplayed(true);
    }
  };

  const convertTextToHtml = (text) => {
    // Split the text into paragraphs based on line breaks
    const paragraphs = text.split("\n");
    // Map each paragraph to wrap it with <p> tags and handle line breaks
    const htmlContent = paragraphs.map((paragraph) => {
      // Replace consecutive line breaks with <br> tags within the paragraph
      const paragraphWithBreaks = paragraph.replace(/\n{2,}/g, "<br><br>");
      // Wrap the paragraph with <p> tags
      return `<p>${paragraphWithBreaks}</p>`;
    });
    // Join the paragraphs into a single HTML string
    return htmlContent.join("");
  };

  const handleFileChange = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".docx,.txt";
    fileInput.style.display = "none";

    fileInput.addEventListener("change", async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type === "application/pdf") {
        toast.warn("PDF is not supported.");
        return;
      }

      // 📌 Handle TXT Upload
      if (file.name.endsWith(".txt")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          editorRef.current.innerText = e.target.result;
          editorRef.current.focus();
        };
        reader.readAsText(file);
        return;
      }

      // 📌 Handle DOCX Upload + IMAGES 🚀
      if (file.name.endsWith(".docx")) {
        try {
          const arrayBuffer = await file.arrayBuffer();

          const result = await mammoth.convertToHtml({
            arrayBuffer,
            convertImage: mammoth.images.inline(async (image) => {
              const imageBuffer = await image.read();
              return {
                src: `data:${image.contentType};base64,${imageBuffer.toString(
                  "base64"
                )}`,
              };
            }),
          });

          const htmlContent = result.value;

          editorRef.current.innerHTML = htmlContent;
          focusEditorAtEnd();
        } catch (err) {
          console.error("DOCX Error:", err);
          toast.error("Failed to read DOCX file");
        }
        return;
      }

      toast.warning("Upload only .txt or .docx files");
    });

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  };

  ////////////////    MIC FUNCTIONALITY   /////////////////////////////////////
  const handleMicClick = () => {
    if(accessToMic == false){
      setSubReqOpen(true)
      setIsFeatureInside(true)
      return
    }
    if (SpeechRecognition.browserSupportsSpeechRecognition()) {
      if (isRecording) {
        SpeechRecognition.stopListening();
        // handleSpeechInput(transcript);
        resetTranscript();
        console.log("mictesting", transcript);
      } else {
        SpeechRecognition.startListening({ continuous: true });
      }
      setIsRecording(!isRecording);
    } else {
      toast.error("Speech recognition is not supported by your browser.");
    }
  };

  const handleTranscriptChange = () => {
    // This function will be called whenever the transcript changes
    if (transcript) {
      handleSpeechInput(transcript);
    }
  };

  const handleSpeechInput = (input) => {
    console.log("inputMic_", input);
    if (input.trim() !== "") {
      // setEditorContent(input);
      if (editorRef.current) {
        editorRef.current.insertAdjacentHTML("beforeend", input);
      }

      // if (editor.current) {
      //   const presentContent = editor.current.value;
      //   const processedHtmlContent = presentContent
      //     .replace(/<br\s*\/?>/gi, "\n")
      //     .replace(/<div\s*\/?>/gi, "\n");
      //   const tempElement = document.createElement("div");
      //   tempElement.innerHTML = processedHtmlContent;
      //   const textContent = tempElement.innerText.trim();
      //   const content = `<p>${textContent} ${input}</p>`;
      //   setEditorContentUpload(content);
      // }
    }
  };

  ////////////////  MIC FUNCTIONALITY END /////////////////////////////////////

  const handleTextEditor = (data, wordsCount, characterCount) => {
    const textData = `{\"blocks\":[{\"key\":\"9ukr0\",\"text\":\"${editorContent}\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}`;
    setCircularLoader(false);
    console.log(
      "editorData_",
      data,
      wordsCount,
      characterCount,
      docId,
      newDocId
    );
    const socketData = {
      documentName: docName,
      documentId: docId !== undefined ? docId : newDocId,
      onlyDocumentContent: data,
      // onlyDocumentContentText: textData,
      formattedDocumentContent: data,
      wordsCount,
      characterCount,
      folder: folderId ? folderId : null,
      tags: tags,
      //imageUrl: image,
    };
    if (clickState === "blog") {
      autoSaveBlogContent(socketData);
    } else {
      autoSaveContent(socketData);
    }
  };

  const autoSaveContent = async (data) => {
    console.log("inside_autosave", data, accessToEdit);
    try {
      if (!accessToEdit) {
        return;
      }
      if (
        data.onlyDocumentContent == "" ||
        data.documentName == "" ||
        data.documentId == ""
      ) {
        setNewSentences([]);
        return;
      }
      const response = await documentService.autoSaveDocument(data);
      if (response.status === 200) {
        //toast.success("Document Saved");
        setCircularLoader(true);
        setMountedFromUpload(false);
        setDocCurrentContent(data.onlyDocumentContent);
        console.log("editorValue_", editorValue);
        if (editorValue !== "") {
          if (isCoAuthor) {
            if (clickSubmitForReview) {
              return;
            }
          }
          console.log("isGrammarCheck_", isGrammarCheck);
          if (isGrammarCheck) {
            grammarCheckClick();
          }
        }
      }
    } catch (error) {
      console.error("Error occurred during auto save:", error);
    } finally {
      setLoading(false);
    }
  };

  const autoSaveContent22 = async (data) => {
    if (!accessToEdit) {
      return;
    }
    setLoading(true);

    try {
      const response = await documentService.autoSaveDocument(data);
      if (response.status === 200) {
        setCircularLoader(true);
        setMountedFromUpload(false);
      }
    } catch (error) {
      console.error("Error occurred during auto save:", error);
    } finally {
      setLoading(false);
    }
  };

  const autoSaveBlogContent = async (data) => {
    try {
      if (
        data.onlyDocumentContent == "" ||
        data.documentName == "" ||
        data.documentId == ""
      ) {
        return;
      }
      console.log(data, "dataa from autosave blog");
      const response = await blogService.autoSaveBlog(data);
      if (response.status === 200) {
        console.log("Auto save bloggg successful:", response);
        setCircularLoader(true);
        setMountedFromUpload(false);
      }
    } catch (error) {
      console.error("Error occurred during auto save:", error);
    }
  };

  const autoSaveBlogContent22 = async (data) => {
    try {
      console.log(data, "dataa from autosave blog");
      const response = await blogService.autoSaveBlog(data);
      if (response.status === 200) {
        console.log("Auto save bloggg successful:", response);
        setCircularLoader(true);
        setMountedFromUpload(false);
      }
    } catch (error) {
      console.error("Error occurred during auto save:", error);
    }
  };

  const handleChildStateChange = (newChildState) => {
    // Handle the child state change in the parent component

    console.log("newChildState_", newChildState);
    try {
      if (newChildState) {
        editorRef.current.innerText = newChildState;
      } else {
        // Handle the case when newChildState is null or undefined
        setEditorContent("");
      }
    } catch (error) {
      console.error("Error handling child state change:", error);
    }
  };

  const passNametoCoNewProject = (name) => {
    if (name) {
      // Concatenate the name with existing editor content
      const updatedContent = editorContent + ` - ${name}`;
      // setEditorContent(updatedContent)
      setEditorContentUpload(updatedContent);
    }
  };

  const fetchData = async () => {
    try {
      if (clickState === "blog") {
        const data = {
          documentName: `${docName}`,
          documentType: clickState === "blog" ? "blog" : "document",
        };
        const documentId = await blogService.saveBlogs(data);
        const data1 = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "createBlog",
        };

        const addLogs = await addUserLogs(data1);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
        // Set apiCalled to true to prevent further API calls
        setNewDocId(documentId);
        setBlogApiCalled(true);
        handleTagGenerator(documentId, "blogs");
        setCircularLoader(true);
      } else {
        const data = {
          documentName: `${docName}`,
          documentType: clickState === "blog" ? "blog" : "document",
        };
        const documentId = await documentService.saveDocs(data);
        const data1 = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "newDoc",
        };

        const addLogs = await addUserLogs(data1);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
        // Set apiCalled to true to prevent further API calls
        console.log("document_ID", documentId);
        setNewDocId(documentId);
        setDocApiCalled(true);
        handleTagGenerator(documentId, "document");
        setCircularLoader(true);
      }
    } catch (error) {
      // Handle error
      console.error("Error occurred:", error);
    }
  };

  // Function to execute after user stops typing
  const handleStoppedTyping = () => {
    setIsTyping(false);
    // setLoading(true)
    console.log("handleEditorChange_2");
    const currentInputText = editorValue;
    console.log("Parachanges_", currentInputText);

    if (currentInputText === "" || !isTyping) {
      // setIsSuggestion(false);
      // setSentenceResult([]);
      setNewSentences([]);
      return;
    } else {
      const [wordsCount, characterCount] = strCount(currentInputText);
      // let convertRaw = convertToRaw(editorContent);
      handleTextEditor(currentInputText, wordsCount, characterCount);
    }
  };

  const handleFullSizeEditor = () => {
    dispatch(fullSizeEditor());
    dispatch(closeLeftNavbar());
  };
  const handleNormalSizeEditor = () => {
    dispatch(normalSizeEditor());
    dispatch(openLeftNavbar());
  };

  const grammarCheckClick = async () => {
    const checkailimit = await checkAIRequestLimit(userID);
    console.log(checkailimit, "_checkailimit", editorContent);
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    let filterArray = [];
    let filtersentence;
    let sentencesArray = editorValue
      // Remove extra dots at the end of sentences (e.g., "sentence.." → "sentence.")
      .replace(/\.+/g, ".")
      // Split into sentences
      .split(".")
      // Remove empty strings
      .filter((s) => s.trim())
      // Add a dot only if missing
      .map((s) => {
        const trimmed = s.trim();
        return trimmed.endsWith(".") ? trimmed : trimmed + ".";
      });
    console.log("textContent_", newSentences, sentencesArray);

    if (newSentences.length > 0) {
      filterArray = sentencesArray.filter(
        (item) => !newSentences.includes(item)
      );
      if (filterArray.length == 0) {
        if (sentenceResult.length == 0) {
          handleCheckGrammarFluency(editorContent, filterArray);
        } else {
          handleCheckGrammarFluency(editorContent, newSentences);
        }
        // setIsAllFix(true)
        // setIsSuggestion(false)
        setLoading(false);
        return;
      }
      filtersentence = filterArray.filter((item) => {
        return item !== "";
      });
    } else {
      filtersentence = sentencesArray.filter((item) => {
        return item !== "";
      });
    }

    handleCheckGrammarFluency(editorContent, filtersentence);

    console.log(filtersentence, filtersentence.length, "kokoo");

    // for (let i = 0; i < filtersentence.length; i++) {
    //   let firstSentence = filtersentence.slice(i, i + 2);
    //   console.log(
    //     "filtersentence",
    //     filtersentence.length,
    //     i,
    //     filtersentence[i]
    //   );
    //   // let mergesentence = (firstSentence.length > 1) ? firstSentence[0] + '.' + firstSentence[1] + '.' : firstSentence[0] + '.' + "This is the end of the content"
    //   // if(sentencesArray.length - 1 == i){
    //   //    filtersentence =firstSentence[0] + '.' + "This is the end of the content"
    //   // }
    //   finalArray.push(filtersentence[i]);
    // }
    // console.log(finalArray, "kokoo");

    // if (isAllFix) {
    // for (const [i, item] of finalArray.entries()) {
    //   await checkGrammarWords(item, i);
    // }
    await checkGrammarWords(editorValue, 0);

    // }
  };

  const ocrCheck = async () => {
    const checkailimit = await checkAIRequestLimit(userID);
    console.log(checkailimit, "_checkailimit");
    if (checkailimit == false) {
      toast.warn("AI request limit reached.");
      return;
    }
    setLoading(true);

    // Perform OCR check and get the response
    const response = await checkOCR(editorHtmlContent);

    if (response.status === 200) {
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "OCR",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
      // Extract the list of OCR results
      const { results } = response;

      // Create a temporary DOM to manipulate the editor content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = editorHtmlContent;

      // Find all the image tags in the editor content
      const images = tempDiv.querySelectorAll("img");

      // Loop through each image in the editor content
      images.forEach((img) => {
        // Get the src of the current image
        const imgSrc = img.getAttribute("src");

        // Find the matching OCR result based on the image src
        const result = results.find((res) => res.src === imgSrc);

        if (result && result.ocrResult) {
          // Prepare the OCR result by replacing `/n` with `<br>` and removing `\"`
          const formattedOCRResult = result.ocrResult
            .replace(/\n/g, "<br>")
            .replace(/\\"/g, '"');

          // Create a new p tag to insert the OCR result below the image
          const pTag = document.createElement("p");
          pTag.innerHTML = formattedOCRResult;

          // Insert the p tag after the image
          img.insertAdjacentElement("afterend", pTag);
        }
      });

      // Update the editor with the modified HTML content
      setEditorContentUpload(tempDiv.innerHTML);
    } else if (response.status === 400) {
      toast.error(response.message);
    } else {
      toast.error("OCR extraction failed");
    }
    setLoading(false);
  };

  const handleTagGenerator = async (id, type) => {
    let payload = {
      documentId: id,
      documentType: type,
    };
    const response = await documentService.generateAutoTag(payload);
    console.log("tagresponse_", response);
  };

  const handleNewproject = (value) => {
    if (value === true) {
      setEditorContent("");
      setShowTranslateModel(false);
      setShowSummariser1(false);
      setShowParaphraser1(false);
    }
  };

  const editorStyle = {
    transition: "width 0.3s",
    maxWidth: "100%",
    width: !mobileView
      ? !selectedEditOption
        ? !selectedEditOption
          ? "120%"
          : "100%"
        : (trackIsModelOpen && rightModalOpen) || lowerModelOpen
        ? isSuggestion
          ? "100%"
          : "100%"
        : "100%"
      : "100%",
    // height: !selectedEditOption ? "500px" : "100%",
    // minHeight: "320px",
    // border: "1px solid red"
  };

  const handleBackButton = () => {
    if (selectedEditOption || sharedDocument) {
      if (isCoAuthor) {
        history.push("/coauthor");
      } else {
        history.goBack();
      }
    }
    dispatch(resetTemplateName(""));
    dispatch(openLeftNavbar());
    handleMenuItemClick("Editor View");
  };

  const submitForReview = async () => {
    swal({
      title: "Review Document",
      text: "Submit your Document for Review ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (reviewDoc) => {
      console.log("DocID_", docId);
      if (reviewDoc) {
        let payload = {
          userId: userID,
          id: docId,
        };
        try {
          const response = await reviewDocument(payload);
          if (response.status !== 200) {
            toast.error(response.message);
          } else {
            toast.info(response.message);
            setClickSubmitForReview(true);
          }
          // Perform any additional actions after submission
        } catch (error) {
          console.error("Error submitting for review:", error);
          toast.error("An error occurred while submitting for review");
        }
      }
    });
  };

  const handleChangeEditor = (e) => {
    console.log("inside_editor", e.target.textContent);
    const html = e.target.innerHTML; // rich HTML
    const text = e.target.textContent;
    setEditorValue(text);
    if (editorRef.current) {
      console.log("handleEditorChange_", editorRef.current.innerText);
      // setEditorContent(e.target.value)
      setIsTyping(true);
      // return
      // setCircularLoader(false);
      const htmlContent = editorRef.current;
      // Access the HTML content
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Count the number of <img> tags
      const imgTags = doc.getElementsByTagName("img");
      const imgCount = imgTags.length;

      setImgInEditor(imgCount);

      let wordCount = 0;
      let textContent = "";
      wordCount = text.split(/\s+/).length;
      const orgName = userDetails?.user?.currentUser?.organizationName;

      if (wordCount > 2500 && orgName !== "BostonBrooks Advisory") {
        // Undo the latest change to prevent new content addition
        editorRef.current.execCommand("undo"); // Undo the last action
        toast.warning(
          "File content limit exceeded. Truncated content to 2500 words."
        );
      } else {
        // Update word count and editor content normally if limit not exceeded
        console.log("handleEditorChange_e");
        setTotalWords(wordCount);
        setEditorHtmlContent(htmlContent);
        setEditorContent(textContent);
        // setPreviousText(textContent);
        setAcceptAllClicked(false);
      }
    }
  };

  const checkGrammarWords = async (inputtext, index) => {
    console.log("grammarResponse_", inputtext);
    // setLoading(true)
    setSuggestionLoader(true);
    let data = {
      text: inputtext,
    };
    // if (index == indexValid) {
    let grammarResponse = await checkGrammar(data);
    if (grammarResponse?.data == "" || grammarResponse?.data == null) {
      console.log("grammarResponse_1", grammarResponse);
      // setLoading(false)
      setSuggestionLoader(false);
      // setIsNull(1)
      // toast.warn("failed to check grammar")
      return;
    }

    let responseOutput = grammarResponse?.data.errors;
    // let responseOutput = "\n{\n  \"replacements\": [\n    {\n      \"value\": \"the\",\n      \"phrase\": \"The the\",\n      \"start_position\": 8,\n      \"corrective_text\": \"The\",\n      \"type_of_error\": \"grammatical\",\n      \"justification\": \"Removing redundant use of article 'the'.\"\n    },\n    {\n      \"value\": \"Sun\",\n      \"phrase\": \"sUn\",\n      \"start_position\": 22,\n      \"corrective_text\": \"Sun\",\n      \"type_of_error\": \"spelling\",\n      \"justification\": \"Correct spelling of 'Sun'.\"\n    },\n    {\n      \"value\": \"a\",\n      \"phrase\": \"A beautiful\",\n      \"start_position\": 43,\n      \"corrective_text\": \"a beautiful\",\n      \"type_of_error\": \"grammatical\",\n      \"justification\": \"Adding article 'a' before the adjective 'beautiful'.\"\n    }]}"
    // let finaloutput = responseOutput.message.tool_calls[0].function.arguments;
    // console.log("trychangedJSon_", finaloutput, index)

    // grammarCheckArray.push(responseOutput);
    if (responseOutput?.length > 0) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      console.log("grammarCheckArray", responseOutput);
      setSentenceResult(responseOutput);
      const data1 = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "check grammer",
      };
      const addLogs = await addUserLogs(data1);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
    }
  };

  const handleCheckGrammarFluency = async (inputtext, filterSentence) => {
    let data = {
      text: inputtext,
    };
    let checkGrammarFluencyResponse = await checkGrammarFluency(data);
    console.log("checkFluency_", checkGrammarFluencyResponse, filterSentence);
    if (filterSentence.length == 0) {
      // setIsSuggestion(false);
    } else {
      setIsSuggestion(true);
    }
  };

  const closeAIAssistant = () => {
    setIsAIOpen(false);
  };

  const handleFormality = (e) => {
    console.log("handleFormality", e.target.id, formality);
    let objID = e.target.id;
    setFormality(objID);
  };

  const handleTone = (e) => {
    console.log("handleTone", e.target.id, tone);
    let objID = e.target.id;
    setTone(objID);
  };

  const handleProfession = (e) => {
    console.log("handleProfession", e);
    let value = e.target.value;
    setProfession(value);
  };

  const updateAIAssistant = () => {
    console.log("updateAIAssistant", formality, tone, profession);
    closeAIAssistant();
  };

  const handleAIReview = () => {
    setshowAireviewContent(true);
    setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
  };

  const handleCloseModal = () => {
    setshowAireviewContent(false);
    dispatch(
      mobileView ? closeRightModal() : closeRightModalAndOpenLeftNavbar()
    );
    setTrackIsModalOpen(false);
  };

  return (
    <>
    <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} isFeatureInside={isFeatureInside} setIsFeatureInside={setIsFeatureInside} path={"mydocuments"}/>
      {/* Coauthor calling */}
      {selectedEditOption && isCoAuthor && !mobileView && !isSuggestion && (
        <CoauthorModal
          trial={trial}
          userId={userId}
          state={editorContent}
          setEditorState={setEditorState}
          setState={setEditorContent}
          count={totalWords}
          passNametoCoNewProject={passNametoCoNewProject}
          setTrackIsModalOpen={setTrackIsModalOpen}
          editorValue={editorValue}
        />
      )}

      {rightModalOpen && (isGrammarCheck || showAireviewContent) && (
        <div
          className="Serive_div changeBG"
          style={{
            width: mobileView ? "65%" : "468px",
            overflow: "scroll",
            zIndex: "1000",
            height: "100vh",
            position: "absolute",
            top: "70px",
            right: "0px",
            border: "1px solid  black",
            padding: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid black ",
              marginTop: "0px",
            }}
          >
            <div style={{ display: "flex", marginBottom: "0px" }}>
              <div
                style={{
                  border: "1px solid black",
                  borderTop: "none",
                  borderBottom: "none",
                }}
              >
                <IconButton
                  disableTouchRipple
                  style={{
                    backgroundColor: showAireviewContent
                      ? "transparent"
                      : "transparent",
                    borderRadius: "0px",
                    border: "none",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => handleAIReview()}
                >
                  <div
                    style={{
                      color: "green",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={aireviewicon}
                      alt="AI Review"
                      style={{ width: "28px" }}
                    />
                    {showAireviewContent && (
                      <h6
                        style={{
                          color: "green",
                          marginLeft: "2px",
                          marginBottom: "0px",
                        }}
                      >
                        AI Review
                      </h6>
                    )}
                    {showGoals && (
                      <h6
                        style={{
                          color: "green",
                          marginLeft: "2px",
                          marginBottom: "0px",
                        }}
                      >
                        Goals
                      </h6>
                    )}
                  </div>
                </IconButton>
              </div>
            </div>
            <div onClick={handleCloseModal}>
              <CloseIcon style={{ cursor: "pointer", color: "Red" }} />
            </div>
          </div>
          {(showAireviewContent || isGrammarCheck) && (
            <CoAuthor_Aireviewcomponent
              mobileView={mobileView}
              editorState={editorContent}
              count={totalWords}
              isGrammarCheck={isGrammarCheck}
              userId={userId}
              trial={trial}
              editorValue={editorValue}
            />
          )}
        </div>
      )}

      <CoAuthorLowerModel
        isDarkMode={isDarkMode}
        mobileView={mobileView}
        editorRef={editorRef}
        editorValue={editorValue}
        showTranslateModel={showTranslateModel}
        handleCloseTranslate={handleCloseTranslate}
        editorState={editorContent}
        setEditorState={setEditorContent}
        selectedContent={selectedContent}
        setSelectedContent={setSelectedContent}
        translator={showTranslator1}
        setTranslator={setShowTranslator1}
        summariser={showSummariser1}
        setSummariser={setShowSummariser1}
        paraphraser={showParaphraser1}
        setParaphraser={setShowParaphraser1}
        callGrammerCheck={callGrammerCheck}
        setCallGrammerCheck={setCallGrammerCheck}
        callSummarise={callSummarise}
        setCallSummarise={setCallSummarise}
        onChildStateChange={handleChildStateChange}
        firstTime={firstTime}
        setFirstTime={setFirstTime}
        righteditorContent={secondaryeditorStateSummarizer}
        handleDeleteinSummarizer={handleDeleteInSummarizer}
        sharedState={sharedState}
        setTrackIsModalOpen={setTrackIsModalOpen}
      />
      {/* } */}

      <Loader loading={loading} />
      
      <div>
        {isGrammarCheck && trial && (
          <div
            className="col-10 row"
            style={{ marginLeft: "10px", marginTop: "40px" }}
          >
            <HeadingB text="Grammar Check"></HeadingB>
          </div>
        )}

        {isCoAuthor && trial && (
          <div
            className="col-10 row"
            style={{ marginLeft: "10px", marginTop: "40px" }}
          >
            <HeadingB text="Co-Author"></HeadingB>
          </div>
        )}
      </div>
      {/* {selectedEditOption && */}

      <>
        <div className="d-flex" style={{ marginLeft: trial ? "25px" : "0px" }}>
          <div
            className={
              // mobileView || (isFullSize && !isCoAuthor)
              mobileView
                ? "col-md-12"
                : isSuggestion
                ? trackIsModelOpen
                  ? "col-md-8"
                  : "col-md-8"
                : (isCoAuthor && rightModalOpen) || lowerModelOpen
                ? "col-md-8 p-0"
                : isCoAuthor
                ? "col-md-11"
                : "col-md-12 p-0"
            }
            style={{
              paddingLeft: "0px",
              paddingRight: mobileView ? "0px" : "",
            }}
          >
            <div style={{ ...editorStyle, minHeight: "90px" }}>
              <CoAutherTopMenubar
                mobileView={mobileView}
                editor={editorRef}
                windowWidth={windowWidth}
                ocrCheck={ocrCheck}
                normalSizeEditor={handleNormalSizeEditor}
                fullSizeEditor={handleFullSizeEditor}
                trial={trial}
                selectedEditOption={selectedEditOption}
                sharedDocument={sharedDocument}
                isCoAuthor={isCoAuthor}
                isGrammarCheck={isGrammarCheck}
                handleMenuItemClick={handleMenuItemClick}
                handleDownload={handleDownloadFormain}
                editorHtmlContent={editorHtmlContent}
                setEditorContentUpload={setEditorContentUpload}
                removeHighlight={removeHighlight}
                setRemoveHighlight={setRemoveHighlight}
                circularLoader={circularLoader}
                setSharedState={setSharedState}
                setDocName={setDocName}
                docName={docName}
                setEditorState={setEditorContent}
                editorState={editorValue}
                newProject={handleNewproject}
                setTotalWords={setTotalWords}
                handleWordCountExceed={handleWordCountExceed}
                setMaxCountDisplayed={setMaxCountDisplayed}
                docId={docId}
                newDocId={newDocId}
              />
            </div>

            {/* Rich Text Editor start */}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "2%",
                alignItems: "center",
              }}
            >
              {sharedDocument && !viewOnlyAccess && docId && (
                <div
                  style={{
                    width: "auto",
                    height: "43px",
                    position: "absolute",
                    top: "88px",
                    right: !selectedEditOption
                      ? !selectedEditOption
                        ? "10px"
                        : "5px"
                      : (trackIsModelOpen && rightModalOpen) || lowerModelOpen
                      ? sentenceResult.length > 0
                        ? "5px"
                        : "34%"
                      : "5px",
                  }}
                >
                  <Button
                    className="OutlinedDarkBtn3"
                    style={{ marginRight: "15px" }}
                    color="primary"
                    onClick={submitForReview}
                    disabled={clickSubmitForReview}
                  >
                    Submit for Review
                  </Button>
                </div>
              )}

              {docId && !sharedDocument && (
                <div
                  className="changeBG"
                  style={{
                    marginTop: mobileView ? "20px" : "17px",
                    width: "80px",
                    height: "fit-content",
                    position: "absolute",
                    top: "68px",
                    marginRight: "15px",
                    right: !mobileView
                      ? !selectedEditOption
                        ? !selectedEditOption
                          ? "10px"
                          : "5px"
                        : (trackIsModelOpen && rightModalOpen) || lowerModelOpen
                        ? sentenceResult.length > 0
                          ? "5px"
                          : "34%"
                        : "5px"
                      : "0px",
                  }}
                >
                  {/* <Button
                    style={{
                      width: "fit-content",
                      color: "red",
                      marginLeft: "5px",
                      fontSize: mobileView ? "10px" : "11px",
                      marginRight: "5px",
                      padding: mobileView ? "6px 8px" : "6px",
                    }}
                    onClick={handleEditDropdownOpen}
                    className=" OutlinedDarkBtn2"
                    disabled={!accessToEdit}
                  >
                    {selectedEditOption ? (
                      <>
                        <EditIcon
                          style={{
                            fontSize: mobileView ? "10px" : "12px",
                            marginRight: "5px",
                          }}
                        />{" "}
                        Edit
                      </>
                    ) : (
                      <>
                        <VisibilityIcon
                          style={{
                            fontSize: mobileView ? "10px" : "15px",
                            marginRight: "5px",
                          }}
                        />{" "}
                        View
                      </>
                    )}
                    <KeyboardArrowDownIcon
                      style={{
                        fontSize: mobileView ? "10px" : "15px",
                        marginLeft: "4px",
                      }}
                    />
                  </Button> */}

                  {/* <Button onClick={handleInsert}>Insert</Button> */}
                  {/* Dropdown Menu */}
                  <Menu
                    anchorEl={editDropdown}
                    open={Boolean(editDropdown)}
                    onClose={handleEditDropdownClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    style={{ padding: "0px" }}
                  >
                    {/* Editor View Option */}
                    <MenuItem
                      onClick={() => handleMenuItemClick("Editor View")}
                      style={{
                        backgroundColor:
                          selectedEditOption === "Editor View"
                            ? "#F3F4F9"
                            : "transparent",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <ListItemIcon
                          style={{
                            width: "15%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <EditIcon />
                        </ListItemIcon>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "90%",
                          }}
                        >
                          <ListItemText
                            primary="Editor View"
                            style={{
                              fontWeight: "bolder",
                              color:
                                selectedEditOption === "Editor View"
                                  ? "#3f51b5"
                                  : "black",
                            }}
                          />
                          <ListItemText
                            primary="Edit the project directly"
                            style={{ color: "#100c0cff", fontSize: "14px" }}
                          />
                        </div>
                        {selectedEditOption === "Editor View" && (
                          <ListItemIcon
                            style={{
                              width: "15%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CheckIcon />
                          </ListItemIcon>
                        )}
                      </div>
                    </MenuItem>

                    {/* Viewing Option */}
                    <MenuItem
                      onClick={() => handleMenuItemClick("Viewing")}
                      style={{
                        backgroundColor:
                          selectedEditOption === "Viewing"
                            ? "#F3F4F9"
                            : "transparent",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <ListItemIcon
                          style={{
                            width: "15%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RemoveRedEyeIcon />
                        </ListItemIcon>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "90%",
                          }}
                        >
                          <ListItemText
                            primary="Viewing"
                            style={{
                              fontWeight: "bold",
                              color:
                                selectedEditOption === "Viewing"
                                  ? "#3f51b5"
                                  : "black",
                            }}
                          />
                          <ListItemText primary="Read or print the project" />
                        </div>
                        {selectedEditOption === "Viewing" && (
                          <ListItemIcon
                            style={{
                              color: "#271313ff",
                              width: "15%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CheckIcon />
                          </ListItemIcon>
                        )}
                      </div>
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </div>
            {/* <div style={{ ...editorStyle, overflowX: 'auto', position: "relative", boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)', padding: '20px 50px 20px 20px', borderRadius: '8px 8px 0px 0px', background: 'white', overflowY: 'auto' }}> */}

            {/* <div style={{ ...editorStyle }}>
              <JoditEditorComp
                onChange={handleChangeEditor}
                editorContent={editorContent}
                editorHtmlContent={editorHtmlContent}
                editor={editor}
                isEdit={selectedEditOption}
                setEditorContentUpload={setEditorContentUpload}
              />
            </div> */}
            <div style={{ ...editorStyle }}>
              <RichTextEditor
                editor={editorRef}
                editorContent={editorContent}
                onChange={handleChangeEditor}
                showtoolbar={true}
                readOnly={false}
                editorId={1}
              />
            </div>
            {/* <JoditEditor
                ref={editor}
                value={content}
                config={config}

                // onBlur={onBlur}
                // onBlur={(event) => handleUpdate(event)}
                // onBlur={newContent => setContent(newContent.target.value)}
                // onChange={content => handleChange(content)}
              /> */}

            {selectedEditOption && (
              <>
                <div
                  className="d-flex changeBG borderTop"
                  style={{
                    justifyContent: mobileView ? "center" : "space-between",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "5px",
                    ...editorStyle,
                    boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3), 0 0 0 white",
                    padding: "15px",
                    borderRadius: "0px 0px 8px 8px",
                    minHeight: "90px",
                  }}
                >
                  <div
                    className="px-2"
                    style={{ display: mobileView ? "none" : "" }}
                  >
                    <h6
                      style={{
                        color: "#1976D2",
                        fontSize: "13px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <FiberManualRecordIcon fontSize="small" />
                      <b className="whiteHeading" style={{ marginLeft: "5px" }}>
                        {" "}
                        {totalWords} | 2500 words{" "}
                      </b>
                    </h6>
                  </div>

                  {!trial && (
                    <div
                    // style={{position:"relative", right:"9%"}}
                    >
                      {/* <Button1
                      variant='outlined'
                      style={{ color: "black", fontSize: '12px', marginRight: '10px', borderRadius: '10px', borderColor: 'black', textTransform: 'capitalize', boxShadow: '3px 3px 8px rgba(0, 0, 0, 0.2)' }}
                      component="label" htmlFor="coAutherFileInput"
                    >
                      <UploadIcon /> Upload
                      <VisuallyHiddenInput
                        id="coAutherFileInput"
                        type="file"
                        key={inputKey}
                        onChange={handleFileChange}  // Directly call the function here
                      />

                    </Button1>  */}

                      <Button
                        disabled={!accessToParaphrase}
                        className="OutlinedDarkBtn2"
                        style={{
                          cursor: accessToParaphrase
                            ? "pointer"
                            : "not-allowed",
                          fontSize: "12px",
                          marginRight: "10px",
                          borderRadius: "10px",
                          textTransform: "capitalize",
                          boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                        }}
                        onClick={handleParaphraseClick}
                      >
                        {/* <MenuBookIcon style={{ marginRight: '3px' }} />  */}
                        <img
                          src={
                            !accessToParaphrase
                              ? paraphrase_Gray
                              : isDarkMode
                              ? paraphrase_White
                              : paraphrase_logo
                          }
                          alt="Paraphrase"
                          style={{ width: "21px", marginRight: "5px" }}
                        />
                        Paraphrase
                      </Button>
                      <Button
                        disabled={!accessToSummarize}
                        className="OutlinedDarkBtn2"
                        style={{
                          cursor: accessToSummarize ? "pointer" : "not-allowed",
                          fontSize: "12px",
                          marginRight: "10px",
                          borderRadius: "10px",
                          textTransform: "capitalize",
                          boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                        }}
                        onClick={handleSummariserClick}
                      >
                        {/* <ArticleIcon /> */}
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18px"
                          height="18px" fill="currentColor"
                          viewBox="0 0 14 14"
                          style={{ marginRight: '3px' }}
                        >
                          <path d="M8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                        </svg> */}
                        <FaBookOpen
                          style={{
                            marginRight: "5px",
                            width: "18px",
                            height: "18px",
                          }}
                        />
                        Summarize
                      </Button>
                      <Button
                        disabled={!accessToOCR}
                        onClick={() => ocrCheck()}
                        className="OutlinedDarkBtn2"
                        style={{
                          textTransform: "capitalize",
                          fontSize: mobileView ? "10px" : "12px",
                          borderRadius: "10px",
                          boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        OCR
                      </Button>
                      {!isGrammarCheck && (
                        <Button
                          className="OutlinedDarkBtn2"
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            fontSize: "12px",
                            // marginRight: "10px",
                            borderRadius: "10px",
                            textTransform: "capitalize",
                            boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                          }}
                          onClick={grammarCheckClick}
                        >
                          {/* <MenuBookIcon style={{ marginRight: '3px' }} />  */}
                          <Spellcheck />
                          Grammar Check
                        </Button>
                      )}
                    </div>
                  )}
                  <div
                    className="buttons-div"
                    style={{
                      width: mobileView ? "100%" : "",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="px-2"
                      style={{ display: !mobileView ? "none" : "" }}
                    >
                      <h6 style={{ color: "#1976D2", fontSize: "10px" }}>
                        <FiberManualRecordIcon fontSize="small" />
                        <b className="whiteHeading"> {totalWords} words </b>
                      </h6>
                    </div>

                    <div>
                      <CustomTooltip title="Delete">
                        <IconButton
                          disabled={!accessToDelete}
                          title={"Delete"}
                          style={{
                            fontSize: "8px",
                            marginLeft: "2px",
                            color: accessToDelete ? "red" : "#FF6B6B",
                            borderColor: "white",
                            width: mobileView ? "1px" : "",
                          }}
                          onClick={handleDeleteFormain}
                        >
                          <Delete />
                        </IconButton>
                      </CustomTooltip>

                      <CustomTooltip title="Upload and can also drag and drop document here">
                        <IconButton
                          className="uploadcolor"
                          disabled={!accessToUpload}
                          title={"Upload"}
                          style={{
                            fontSize: "8px",
                            marginLeft: "2px",
                            borderColor: "white",
                            width: mobileView ? "1px" : "",
                          }}
                          component="label"
                          htmlFor="coAutherFileInput"
                          onClick={() => handleFileChange()}
                        >
                          <UploadIcon />
                          {/* <VisuallyHiddenInput
                          id="coAutherFileInput"
                          type="file"
                          key={inputKey}
                          onClick={handleFileChange} // Directly call the function here
                        /> */}
                        </IconButton>
                      </CustomTooltip>

                      {!trial && docId && (
                        <CustomTooltip title="Download">
                          <IconButton
                            title={"Download"}
                            style={{
                              fontSize: "8px",
                              marginLeft: "2px",
                              color: "green",
                              borderColor: "white",
                              width: mobileView ? "1px" : "",
                            }}
                            onClick={() => {
                              openDownloadModal();
                            }}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </CustomTooltip>
                      )}

                      <CustomTooltip title="Copy">
                        <IconButton
                          title={"Copy"}
                          style={{
                            fontSize: "8px",
                            marginLeft: "2px",
                            color: "blue",
                            borderColor: "white",
                            width: mobileView ? "1px" : "",
                          }}
                          onClick={handleCopyFormain}
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </CustomTooltip>
                      {!trial && (
                        <CustomTooltip title="Translate">
                          <IconButton
                            className="translateColor"
                            disabled={!accessToTranslate}
                            title="Translate"
                            style={{
                              fontSize: "8px",
                              marginLeft: "2px",
                              borderColor: "white",
                              width: mobileView ? "1px" : "",
                            }}
                            onClick={handleTranslateClick}
                          >
                            <TranslateIcon />
                          </IconButton>
                        </CustomTooltip>
                      )}
                      <CustomTooltip title="Mic">
                        <IconButton
                          title={"Mic"}
                          style={{
                            fontSize: "8px",
                            marginLeft: "2px",
                            color: isRecording ? "red" : "#FF6B6B",
                            borderColor: "white",
                            width: mobileView ? "1px" : "",
                          }}
                          onClick={handleMicClick}
                        >
                          <MicIcon />
                        </IconButton>
                      </CustomTooltip>
                      {/* <IconButton title={"Remove"} style={{ fontSize: '8px', marginLeft: '2px', color: 'black', borderColor: 'white' }}><RemoveIcon /></IconButton> */}
                    </div>
                  </div>
                </div>
                <DownloadOptionModal
                  show={isDownloadModalOpen}
                  onHide={closeDownloadModal}
                  id={docId}
                />

                {/* <div><h6 style={{ marginTop: '15px' }}>
              <FiberManualRecordIcon fontSize='small' />1000 words limit per search |
              <b> Total words: {totalWords}</b>
            </h6></div> */}
              </>
            )}
          </div>

          {isSuggestion && !mobileView && (
            <div
              className="col-md-4"
              style={{
                marginTop: "15px",
                background: "white",
                boxShadow: "0px 2px 5px 0px #000000",
                borderRadius: "5px",
                padding: "7px",
              }}
            >
              {/* {isFeatureButton &&  */}
              <div
                // className=" pt-3"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  color: "#1A1A1A",
                  fontSize: "18px",
                  marginBottom: "10px",
                  backgroundColor: "white",
                  height: "45px",
                  padding: "10px",
                  // display: 'flex',
                  // justifyContent: 'space-between'
                }}
              >
                <div>Suggestions</div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "18px",
                    padding: "0px 5px",
                  }}
                >
                  <div>
                    {/* <button className="btn btn-primary" style={{ borderRadius: '15px', marginRight: '5px' }}
                      onClick={() => { setIgnoreAllClicked(true) }}
                    >Ignore All</button> */}
                    <Button
                      className="cgcancelbtn mr-3"
                      size="small"
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        setIgnoreAllClicked(true);
                      }}
                    >
                      Ignore All
                    </Button>
                  </div>

                  <div>
                    {/* <button className="btn btn-primary" style={{ borderRadius: '15px' }}
                      onClick={() => { setAcceptAllClicked(true) }}
                    >Accept All</button> */}
                    <Button
                      className="cgacceptbtn"
                      size="small"
                      variant="contained"
                      color="success"
                      onClick={() => {
                        setAcceptAllClicked(true);
                      }}
                    >
                      Accept All
                    </Button>
                  </div>
                </div>
              </div>

              <SuggestionComp
                autoSaveContent={autoSaveContent}
                windowWidth={windowWidth}
                ignoreAllClicked={ignoreAllClicked}
                setIgnoreAllClicked={setIgnoreAllClicked}
                acceptAllClicked={acceptAllClicked}
                setAcceptAllClicked={setAcceptAllClicked}
                editorHtmlContent={editorHtmlContent}
                sentenceResult={sentenceResult}
                setSentenceResult={setSentenceResult}
                editorValue={editorValue}
                setEditorValue={setEditorValue}
                setIsSuggestion={setIsSuggestion}
                editor={editorRef}
                ignoredSuggestions={ignoredSuggestions}
                setNewSentences={setNewSentences}
                newSentences={newSentences}
                suggestionLoader={suggestionLoader}
              />
              {/* <WordComparer string1={state.paraText} sentence2={"Despite having studied extensively for the exam, their performance was not as good as she had hoped."} /> */}
            </div>
          )}

          {/* Mobile View */}

          {isSuggestion && mobileView && (
            <div
              className="mobile-gc"
              style={{
                marginTop: "75px",
                backgroundColor: "white",
                height: "70vh",
                width: "60%",
                position: "fixed",
                right: "5px",
                border: "1px solid  black",
                zIndex: "998",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {/* {isFeatureButton &&  */}
              <>
                <div
                  // className=" pt-3"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    color: "#1A1A1A",
                    fontSize: "18px",
                    marginBottom: "10px",
                    backgroundColor: "white",
                    height: "45px",
                    padding: "7px",
                    borderRadius: "7px",
                    // display: 'flex',
                    // justifyContent: 'space-between'
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ fontSize: "15px" }}>Suggestions</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "18px",
                      padding: "0px 5px",
                    }}
                  >
                    <div>
                      <button
                        className="btn btn-primary"
                        style={{
                          borderRadius: "15px",
                          marginRight: "10px",
                          fontSize: "10px",
                        }}
                        onClick={() => {
                          setIgnoreAllClicked(true);
                        }}
                      >
                        Ignore All
                      </button>
                    </div>

                    <div>
                      <button
                        className="btn btn-primary"
                        style={{ borderRadius: "15px", fontSize: "10px" }}
                        onClick={() => {
                          setAcceptAllClicked(true);
                        }}
                      >
                        Accept All
                      </button>
                    </div>
                  </div>
                </div>

                <SuggestionComp
                  autoSaveContent={autoSaveContent}
                  windowWidth={windowWidth}
                  ignoreAllClicked={ignoreAllClicked}
                  setIgnoreAllClicked={setIgnoreAllClicked}
                  acceptAllClicked={acceptAllClicked}
                  setAcceptAllClicked={setAcceptAllClicked}
                  editorHtmlContent={editorHtmlContent}
                  sentenceResult={sentenceResult}
                  setSentenceResult={setSentenceResult}
                  editorValue={editorValue}
                  setEditorValue={setEditorValue}
                  setIsSuggestion={setIsSuggestion}
                  editor={editorRef}
                  ignoredSuggestions={ignoredSuggestions}
                  setNewSentences={setNewSentences}
                  newSentences={newSentences}
                  suggestionLoader={suggestionLoader}
                />
                {/* <WordComparer string1={state.paraText} sentence2={"Despite having studied extensively for the exam, their performance was not as good as she had hoped."} /> */}
              </>
            </div>
          )}
          {/* Mobile View */}
        </div>

        {selectedEditOption && isCoAuthor && mobileView && !isSuggestion && (
          <div className="col-md-12">
            <CoauthorModal
              trial={trial}
              userId={userId}
              state={editorContent}
              editorState={editorState}
              setEditorState={setEditorState}
              setState={setEditorContent}
              count={totalWords}
              passNametoCoNewProject={passNametoCoNewProject}
              setTrackIsModalOpen={setTrackIsModalOpen}
              mobileView={mobileView}
              editorValue={editorValue}
            />
          </div>
        )}
      </>

      {/* AI Assistant Modal start */}
      <Modal
        isOpen={isAIOpen}
        toggle={() => setIsAIOpen(!isAIOpen)}
        style={{
          position: "absolute",
          left: "43%",
          top: "25%",
        }}
      >
        <ModalHeader
          toggle={() => setIsAIOpen(!isAIOpen)}
          // className="text-center"
        >
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              color: "#303030",
              fontSize: "1rem",
            }}
          >
            AI Assistant
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="">
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                color: "#303030",
                fontSize: "1rem",
              }}
            >
              Formality
            </p>

            <TagButtonComp
              id="neutral"
              name="Neutral"
              className="ml-2"
              onClickTagButton={handleFormality}
            />

            <TagButtonComp
              id="casual"
              name="Casual"
              className="ml-2"
              onClickTagButton={handleFormality}
            />

            <TagButtonComp
              id="formal"
              name="Formal"
              className="ml-2"
              onClickTagButton={handleFormality}
            />
          </div>
          <div className="mt-3">
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                color: "#161515ff",
                fontSize: "1rem",
              }}
            >
              Tone
            </p>
            <div>
              <TagButtonComp
                id="personable"
                name="Personable"
                className="ml-2"
                onClickTagButton={handleTone}
              />

              <TagButtonComp
                id="confident"
                name="Confident"
                className="ml-2"
                onClickTagButton={handleTone}
              />

              <TagButtonComp
                id="empathetic"
                name="Empathetic"
                className="ml-2"
                onClickTagButton={handleTone}
              />
            </div>
            <div className="mt-2">
              <TagButtonComp
                id="engaging"
                name="Engaging"
                className="ml-2"
                onClickTagButton={handleTone}
              />

              <TagButtonComp
                id="witty"
                name="Witty"
                className="ml-2"
                onClickTagButton={handleTone}
              />

              <TagButtonComp
                id="direct"
                name="Direct"
                className="ml-2"
                onClickTagButton={handleTone}
              />
            </div>
          </div>
          <div className="mt-4">
            <SelectDropdownMui
              optionsList={professionList}
              selectLabel={"Your Profession"}
              onChange={handleProfession}
              value={profession}
            />
          </div>
          <div className="mt-3 d-flex justify-content-end">
            <button className="btn btn-primary" onClick={updateAIAssistant}>
              Update
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CoAuthorNewProject;
